import { render } from "./ConfirmedPage.vue?vue&type=template&id=4f93e508&scoped=true"
import script from "./ConfirmedPage.vue?vue&type=script&lang=js"
export * from "./ConfirmedPage.vue?vue&type=script&lang=js"

import "./ConfirmedPage.vue?vue&type=style&index=0&id=4f93e508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f93e508"]])

export default __exports__